import { render, staticRenderFns } from "./InsuranceHerbMedicine.vue?vue&type=template&id=8f4f006c&scoped=true"
import script from "./InsuranceHerbMedicine.vue?vue&type=script&lang=js"
export * from "./InsuranceHerbMedicine.vue?vue&type=script&lang=js"
import style0 from "./InsuranceHerbMedicine.vue?vue&type=style&index=0&id=8f4f006c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4f006c",
  null
  
)

export default component.exports